import { Component, inject, NgZone, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@shared/components/header/header.component';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { MainTemplateComponent } from '@templates/main-template/main-template.component';
import { ApiConfig } from './services/api.config';
import { E_FR_LOC } from '@shared/constants/enums.const';
import { BaseComponent } from '@shared/classes/base.class';
import { AuthenticationService } from './services/authentication.service';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SideHeaderComponent } from '@shared/components/side-header/side-header.component';
import { BehaviorSubject, take } from 'rxjs';
import { ContentService } from './services/content.service';
import { TranslateService } from '@ngx-translate/core';
import { HelperService } from './services/helper.service';
import { ResponsivityService } from './services/responsivity.service';
import { CookieConsentService } from './services/cookie-consent.service';
import { AdobeAnalyticsService } from './services/adobe-analytics.service';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    MainTemplateComponent,
    HeaderComponent,
    FooterComponent,
    MatSidenavModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    SideHeaderComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent extends BaseComponent implements OnInit {
  isMobileMenuOpen!: BehaviorSubject<boolean>;
  HELPER: HelperService = inject(HelperService);

  COOKIE_CENT = inject(CookieConsentService);

  constructor(
    protected apiConfig: ApiConfig,
    protected CONTENT: ContentService,
    private authService: AuthenticationService,
    private translate: TranslateService,
    private responsivityService: ResponsivityService,
    private adobeAnalytics: AdobeAnalyticsService,
    private ngZone: NgZone,
  ) {
    super();
    this.translate.addLangs(['de', 'en', 'fr']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  override ngOnInit() {

    this.apiConfig.initAppConfig()
      .pipe(take(1))
      .subscribe(() => {
          super.ngOnInit();
          this.checkFrLoc();

          if (this.HELPER.loginEnabled) {
            this.authService.setConfig();
            this.handleUserSignIn();
          }
          this.COOKIE_CENT.init();
          this.adobeAnalytics.init();
        },
      );
    this.handleResponsivity();
  }

  handleResponsivity(): void {
    this.responsivityService.handleMenuToggle();
    this.isMobileMenuOpen = this.responsivityService.isMenuOpen;
  }

  override onReload() {
    this.checkFrLoc();
  }

  handleUserSignIn() {
    // handle code param in url
    this.authService.handleAuthCode();
    // if user data in storage - set user session
    this.authService.fetchAuthSession().then(session => {
      if (session) {
        this.authService.refreshToken = session.getRefreshToken();
        this.authService.setSession(session);
        this.authService.getUser().then(user => {
          this.authService.user.next(user);
        });
      }
    }).catch(error => {
      console.log(error);
      this.authService.signOut().then(() => {
        this.authService.user.next(null);
        // this.router.navigate([`${this.HELPER.frLoc}/home`]);
      });
    });
  }

  changeMenuState(menuState: boolean): void {
    this.responsivityService.isMenuOpen.next(menuState);
  }

  checkFrLoc() {
    const frLoc = this.HELPER.getFrLocFromUrl();
    if (frLoc && frLoc !== this.HELPER.frLoc) {
      this.HELPER.frLoc = frLoc as E_FR_LOC;
      this.HELPER.changeFrLoc(frLoc);
    }
  }


}
